import React from 'react';
import '../template-file-css/document-file-template.css';


export const SSS_PsychiatricFollowUp = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='SSS_PsychiatricFollowUp' className='file-pdf-document'>
            <div className='file-template'>
                <p className='w-750'>
                    <b>
                        <center>PSYCHIATRIC FOLLOW-UP PROGRESS NOTE</center>
                    </b></p>
                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>CLIENT NAME:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>DOB:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>  <input type='text' id='txtClientName' name='txtClientName' className='add-only' />  </td>
                        <td className='w-375'> <input type='date' id='txtDob' name='txtDob' className='add-only' />  </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>DATE of SERVICE:</span> </td></tr>
                    <tr>
                        <td className='w-375'>  <input type='date' id='txtDateOfService_1' name='txtDateOfService_1' className='add-only' />  </td>

                        <td className='w-375'>
                            <input type='checkbox' id='cbTelehealth' name='cbTelehealth' className='add-only' value='Telehealth' /> TELEHEALTH &nbsp;
                            <input type='checkbox' id='cbInPerson' name='cbInPerson' className='add-only' value='InPerson' /> IN-PERSON &nbsp;
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <b>FULL DIAGNOSIS:</b>

                    <span className='eleHeader'>PRIMARY</span>
                    <textarea id='txtPrimary' name='txtPrimary' className='add-only'></textarea>

                    <span className='eleHeader'>SECONDARY</span>
                    <textarea id='txtSecondary' name='txtSecondary' className='add-only'></textarea>

                    <span className='eleHeader'>TERTIARY</span>
                    <textarea id='txtTertiary' name='txtTertiary' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <b>MEDICATION:</b>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>CURRENT:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbCurrent_1' name='rbCurrent_1' className='add-only' value='Current_1' />  Compliant
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rbCurrent_2' name='rbCurrent_2' className='add-only' value='Current_2' />  Non-Compliant
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>SIDE EFFECTS:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbSideEffects_1' name='cbSideEffects_1' className='add-only' value='SideEffects_1' />  NONE
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>or REPORTS: (ie. NAUSEA/ VOMITTING/ DIARRHEA/DROWSINESS, etc.)</span>

                    <textarea id='txtReports_1' name='txtReports_1' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>IF NEW MEDICATION IS PRESCRIBED:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbNewMedication_1' name='cbNewMedication_1' className='add-only' value='NewMedication_1' /> NEW CONSENT OBTAINED
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>NAME/ INDICATION FOR USE</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>  <input type='text' id='txtNameIndicationForUse_1' name='txtNameIndicationForUse_1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbDiscussedSideEffects' name='cbDiscussedSideEffects' className='add-only' value='DiscussedSideEffects' /> DISCUSSED SIDE EFFECTS
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbContraindications' name='cbContraindications' className='add-only' value='Contraindications' /> CONTRAINDICATIONS
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>NAME/ INDICATION FOR USE</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>  <input type='text' id='txtNameIndicationForUse_2' name='txtNameIndicationForUse_2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbDiscussedSideEffects_2' name='cbDiscussedSideEffects_2' className='add-only' value='DiscussedSideEffects' /> DISCUSSED SIDE EFFECTS
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbContraindications_2' name='cbContraindications_2' className='add-only' value='Contraindications' /> CONTRAINDICATIONS
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>DATA:</span>
                    <textarea id='txtReports_1' name='txtReports_1' className='add-only'></textarea>

                </p>
                <table>

                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbIllicitDrugUse' name='cbIllicitDrugUse' className='add-only' value='IllicitDrugUse' /> Illicit Drug Use
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAlcoholUse' name='cbAlcoholUse' className='add-only' value='AlcoholUse' /> Alcohol Use
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbOtc' name='cbOtc' className='add-only' value='Otc' /> OTC
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHerbalMeds' name='cbHerbalMeds' className='add-only' value='HerbalMeds' /> Herbal Meds
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'> If checked, potential adverse effects addressed/discussed</span>
                    <textarea id='txtIfCheckedPotentialAdverseEffects' name='txtIfCheckedPotentialAdverseEffects' className='add-only'> </textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'><b>SAFETY RISKS:</b></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>RISK of HARM:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbNoHarmEvidence' name='cbNoHarmEvidence' className='add-only' value='NoHarmEvidence' /> NO HARM/EVIDENCE
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbToSelf' name='cbToSelf' className='add-only' value='ToSelf' /> TO SELF
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbToOthers_5' name='cbToOthers_5' className='add-only' value='ToOthers_5' /> TO OTHERS
                        </td>
                    </tr>

                </table>
                <p className='w-750'>
                    <span className='eleHeader'>DESCRIBE: </span>
                    <textarea id='txtDescribe' name='txtDescribe' className='add-only'> </textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'><b>ASSESSMENT:</b>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>PROGRESS TOWARDS GOALS:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbNone' name='cbNone' className='add-only' value='None' /> NONE
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbMinimal' name='cbMinimal' className='add-only' value='Minimal' /> MINIMAL(SLOW IMPROVEMENT)

                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbModerate' name='cbModerate' className='add-only' value='Moderate' /> MODERATE(STABLE)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbMuchImproved' name='cbMuchImproved' className='add-only' value='MuchImproved' /> MUCH IMPROVED
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>PLAN: </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <textarea id='txtPlan' name='txtPlan' className='add-only'> </textarea>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>RTC: </span>
                        </td>
                        <td className='w-250'><span className='eleHeader'>BLOOD PRESSURE: </span>
                        </td>
                        <td className='w-250'><span className='eleHeader'>WEIGHT:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtRtc' name='txtRtc' className='add-only w-100 custom-add-only' />  MONTH(s)/ or PRN
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtBloodPressure_Low' name='txtBloodPressure_Low' className='add-only w-100 custom-add-only' />
                            &nbsp;/&nbsp;
                            <input type='text' id='txtBloodPressure_Heigh' name='txtBloodPressure_Heigh' className='add-only w-100 custom-add-only' />
                        </td>
                        <td className='w-250'>  <input type='text' id='txtWeight' name='txtWeight' className='add-only w-100 custom-add-only' />  LBS.
                        </td>
                    </tr>
                    <tr>
                        <td className='signature w-750'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-750'> RN Signature: </td>

                    </tr> 
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>

                        <td className='small w-375'> PSYCHIATRIST SIGNATURE</td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>
                        MENTAL STATUS EXAMINATION
                        <span className='small'> (Check all that apply) </span>
                    </b>
                </p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>ORIENTATION/ SENSORIUM/ COGNITION</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAlert' name='cbAlert' className='add-only' value='Alert' /> Alert
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbLethargic' name='cbLethargic' className='add-only' value='Lethargic' /> Lethargic
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSomnolent' name='cbSomnolent' className='add-only' value='Somnolent' /> Somnolent
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbStuporous' name='cbStuporous' className='add-only' value='Stuporous' />  Stuporous
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <b>Oriented to:</b></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPerson' name='cbPerson' className='add-only' value='Person' />  Person
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPlace' name='cbPlace' className='add-only' value='Place' />  Place
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbTime' name='cbTime' className='add-only' value='Time' />  Time
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSituation' name='cbSituation' className='add-only' value='Situation' />  Situation
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbNormalConcentration' name='cbNormalConcentration' className='add-only' value='NormalConcentration' />  Normal Concentration
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbImpairedConcentration' name='cbImpairedConcentration' className='add-only' value='ImpairedConcentration' />  Impaired Concentration
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbOrientedOther' name='cbOrientedOther' className='add-only' value='OrientedOther' />  Other:
                            &nbsp;
                            <input type='text' id='txtOrientedOther_1' name='txtOrientedOther_1' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>GENERAL APPERANCE</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHealthy' name='cbHealthy' className='add-only' value='Healthy' />  Healthy
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbOverweight' name='cbOverweight' className='add-only' value='Overweight' />  Overweight
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbThin' name='cbThin' className='add-only' value='Thin' />  Thin
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbObese' name='cbObese' className='add-only' value='Obese' />  Obese
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbUnkempt' name='cbUnkempt' className='add-only' value='Unkempt' /> Unkempt
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAsStatedAge' name='cbAsStatedAge' className='add-only' value='AsStatedAge' /> As stated Age
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbOlderThanStatedAge' name='cbOlderThanStatedAge' className='add-only' value='OlderThanStatedAge' />  Older than Stated Age
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbYounglooking' name='cbYounglooking' className='add-only' value='Younglooking ' /> Young-looking
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbEmaciated' name='cbEmaciated' className='add-only' value='Emaciated' /> Emaciated
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbTattoos' name='cbTattoos' className='add-only' value='Tattoos' /> Tattoos
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbMalodorous' name='cbMalodorous' className='add-only' value='Malodorous' /> Malodorous
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPoorHygiene' name='cbPoorHygiene' className='add-only' value='PoorHygiene' /> Poor-Hygiene
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbDisheveled' name='cbDisheveled' className='add-only' value='Disheveled' /> Disheveled
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbOther_1' name='cbOther_1' className='add-only' value='Other' />  Other:
                            &nbsp;
                            <input type='text' id='txtOther_2' name='txtOther_2' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>FACIAL EXPRESSION</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAppropriateToTopic' name='cbAppropriateToTopic' className='add-only' value='AppropriateToTopic' /> Appropriate to Topic
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSad' name='cbSad' className='add-only' value='Sad' /> Sad
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbWorried' name='cbWorried' className='add-only' value='Worried' /> Worried
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbExpressionless' name='cbExpressionless' className='add-only' value='Expressionless' /> Expressionless
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHostile' name='cbHostile' className='add-only' value='Hostile' /> Hostile
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>BEHAVIOR & PSYCHOMOTOR ACTIVITY</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbNormal' name='cbNormal' className='add-only' value='Normal' /> Normal
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbOveractive' name='cbOveractive' className='add-only' value='Overactive' /> Overactive
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHypoactive' name='cbHypoactive' className='add-only' value='Hypoactive' />  Hypoactive
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbCatatonia' name='cbCatatonia' className='add-only' value='Catatonia' />  Catatonia
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAbnormalGait' name='cbAbnormalGait' className='add-only' value='AbnormalGait' /> Abnormal Gait
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbCombative' name='cbCombative' className='add-only' value='Combative' /> Combative
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbRepetitiveActions' name='cbRepetitiveActions' className='add-only' value='RepetitiveActions' /> Repetitive Actions
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbTremor' name='cbTremor' className='add-only' value='Tremor' /> Tremor
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbTics' name='cbTics' className='add-only' value='Tics' /> Tics
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbOther_3' name='cbOther_3' className='add-only' value='Other' />  Other:
                            &nbsp;
                            <input type='text' id='txtOther_4' name='txtOther_4' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>DRESS</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAppropriate' name='cbAppropriate' className='add-only' value='Appropriate' /> Appropriate
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbEccentricBizarre' name='cbEccentricBizarre' className='add-only' value='EccentricBizarre' /> Eccentric/Bizarre
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSeductive' name='cbSeductive' className='add-only' value='Seductive' /> Seductive
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbMeticulous' name='cbMeticulous' className='add-only' value='Meticulous' /> Meticulous
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbNotAssessed' name='cbNotAssessed' className='add-only' value='NotAssessed' /> Not Assessed
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>ATTITUDE/ INTERVIEW BEHAVIOR</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbCooperative' name='cbCooperative' className='add-only' value='Cooperative' /> Cooperative
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbUncooperative' name='cbUncooperative' className='add-only' value='Uncooperative' /> Uncooperative
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbDefensive' name='cbDefensive' className='add-only' value='Defensive' /> Defensive
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHostile' name='cbHostile' className='add-only' value='Hostile' /> Hostile
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbGuarded' name='cbGuarded' className='add-only' value='Guarded' /> Guarded
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbApathetic' name='cbApathetic' className='add-only' value='Apathetic' /> Apathetic
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAppropriate' name='cbAppropriate' className='add-only' value='Appropriate' /> Appropriate
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAggressive' name='cbAggressive' className='add-only' value='Aggressive' /> Aggressive
                        </td>
                    </tr>
                    <tr>

                        <td className='w-187'>
                            <input type='checkbox' id='cbArgumentative' name='cbArgumentative' className='add-only' value='Argumentative' /> Argumentative
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbChildLike' name='cbChildLike' className='add-only' value='ChildLike' /> Child-like
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbEvasive' name='cbEvasive' className='add-only' value='Evasive' /> Evasive
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAngry' name='cbAngry' className='add-only' value='Angry' /> Angry
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSeductive' name='cbSeductive' className='add-only' value='Seductive' />  Seductive
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbDemanding' name='cbDemanding' className='add-only' value='Demanding' /> Demanding
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbDrastic' name='cbDrastic' className='add-only' value='Drastic' />  Drastic
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbIrritable' name='cbIrritable' className='add-only' value='Irritable' /> Irritable
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbManipulative' name='cbManipulative' className='add-only' value='Manipulative' />  Manipulative
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPassive' name='cbPassive' className='add-only' value='Passive' /> Passive
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>SPEECH</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSpeechNormal' name='cbSpeechNormal' className='add-only' value='SpeechNormal' />  Normal
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSpontaneous' name='cbSpontaneous' className='add-only' value='Spontaneous' /> Spontaneous
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbImpoverished' name='cbImpoverished' className='add-only' value='Impoverished' />  Impoverished
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSoft' name='cbSoft' className='add-only' value='Soft' /> Soft
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbWhispered' name='cbWhispered' className='add-only' value='Whispered' />  Whispered
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHesitant' name='cbHesitant' className='add-only' value='Hesitant' /> Hesitant
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSlowed' name='cbSlowed' className='add-only' value='Slowed' /> Slowed
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbMumbled' name='cbMumbled' className='add-only' value='Mumbled' /> Mumbled
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPressured' name='cbPressured' className='add-only' value='Pressured' /> Pressured
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbImpediment' name='cbImpediment' className='add-only' value='Impediment' /> Impediment
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbStuttering' name='cbStuttering' className='add-only' value='Stuttering' /> Stuttering
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbVerbose' name='cbVerbose' className='add-only' value='Verbose' /> Verbose
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbMonotonous' name='cbMonotonous' className='add-only' value='Monotonous' /> Monotonous
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSlow' name='cbSlow' className='add-only' value='Slow' /> Slow
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbRapid' name='cbRapid' className='add-only' value='Rapid' /> Rapid
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbLoud' name='cbLoud' className='add-only' value='Loud' /> Loud
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbMute' name='cbMute' className='add-only' value='Mute' /> Mute
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbOther_5' name='cbOther_5' className='add-only' value='Other' />  Other:
                            &nbsp;
                            <input type='text' id='txtOther_6' name='txtOther_6' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>MOOD</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbDysphoric' name='cbDysphoric' className='add-only' value='Dysphoric' />  Dysphoric
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbEuthymic' name='cbEuthymic' className='add-only' value='Euthymic' /> Euthymic
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbExpansive' name='cbExpansive' className='add-only' value='Expansive' />  Expansive
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbIrritable' name='cbIrritable' className='add-only' value='Irritable' /> Irritable
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbLabile' name='cbLabile' className='add-only' value='Labile' /> Labile
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbElevated' name='cbElevated' className='add-only' value='Elevated' /> Elevated
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbEuphoric' name='cbEuphoric' className='add-only' value='Euphoric' />  Euphoric
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbEcstatic' name='cbEcstatic' className='add-only' value='Ecstatic' /> Ecstatic
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbDepressed' name='cbDepressed' className='add-only' value='Depressed' /> Depressed
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbGrief/Mourning' name='cbGrief/Mourning' className='add-only' value='Grief/Mourning' /> Grief/Mourning
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAlexithymic' name='cbAlexithymic' className='add-only' value='Alexithymic' /> Alexithymic
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbElated' name='cbElated' className='add-only' value='Elated' /> Elated
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHypomanic' name='cbHypomanic' className='add-only' value='Hypomanic' /> Hypomanic
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbManic' name='cbManic' className='add-only' value='Manic' /> Manic
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAnxious' name='cbAnxious' className='add-only' value='Anxious' /> Anxious
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbTense' name='cbTense' className='add-only' value='Tense' /> Tense
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbGrandiose' name='cbGrandiose' className='add-only' value='Grandiose' /> Grandiose
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbOther_7' name='cbOther_7' className='add-only' value='Other' />  Other:
                            &nbsp;
                            <input type='text' id='txtOther_8' name='txtOther_8' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>AFFECT</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAppropriate' name='cbAppropriate' className='add-only' value='Appropriate' /> Appropriate
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbInappropriate' name='cbInappropriate' className='add-only' value='Inappropriate' /> Inappropriate
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbBlunted' name='cbBlunted' className='add-only' value='Blunted' /> Blunted
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbRestricted' name='cbRestricted' className='add-only' value='Restricted' /> Restricted
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbFlat' name='cbFlat' className='add-only' value='Flat' /> Flat
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbLabile' name='cbLabile' className='add-only' value='Labile' /> Labile
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbTearful' name='cbTearful' className='add-only' value='Tearful' /> Tearful
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbIntense' name='cbIntense' className='add-only' value='Intense' /> Intense
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbCongruent' name='cbCongruent' className='add-only' value='Congruent' /> Congruent
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbIncongruent' name='cbIncongruent' className='add-only' value='Incongruent' /> Incongruent
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbReactive' name='cbReactive' className='add-only' value='Reactive' /> Reactive
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbConstricted' name='cbConstricted' className='add-only' value='Constricted' /> Constricted
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>INSIGHT</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbExcellent' name='cbExcellent' className='add-only' value='Excellent' /> Excellent
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbGood' name='cbGood' className='add-only' value='Good' /> Good
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPoor' name='cbPoor' className='add-only' value='Poor' /> Poor
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbNil' name='cbNil' className='add-only' value='Nil' /> Nil
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbDenial' name='cbDenial' className='add-only' value='Denial' /> Denial
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbImpairedInsight' name='cbImpairedInsight' className='add-only' value='ImpairedInsight' /> Impaired Insight
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'>
                            <input type='checkbox' id='cbFairSomeAwarenessOfIllnessSymptoms' name='cbFairSomeAwarenessOfIllnessSymptoms' className='add-only ' value='FairSomeAwarenessOfIllnessSymptoms' /> Fair/ Some awareness of illness/ Symptoms
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbOther_9' name='cbOther_9' className='add-only' value='Other' />  Other:
                            &nbsp;
                            <input type='text' id='txtOther_10' name='txtOther_10' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>JUDGMENT/ IMPULSE CONTROL</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbCriticalJudgmentIntact' name='cbCriticalJudgmentIntact' className='add-only' value='CriticalJudgmentIntact' /> Critical Judgment Intact
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbImpairedJudgment' name='cbImpairedJudgment' className='add-only' value='ImpairedJudgment' /> Impaired Judgment
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAbleToResistImpulses' name='cbAbleToResistImpulses' className='add-only ' value='AbleToResistImpulses' /> Able to Resist Impulses
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbImpairedImpulseControl' name='cbImpairedImpulseControl' className='add-only ' value='ImpairedImpulseControl' /> Impaired Impulse Control
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPresent' name='cbPresent' className='add-only ' value='Present' /> Present
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbCompulsions' name='cbCompulsions' className='add-only ' value='Compulsions' /> Compulsions
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbRecentImpulsiveBehavior' name='cbRecentImpulsiveBehavior' className='add-only ' value='RecentImpulsiveBehavior' /> Recent Impulsive Behavior
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbNone_1' name='cbNone_1' className='add-only ' value='None_1' /> None
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>MEMORY</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbNormal_1' name='cbNormal_1' className='add-only' value='Normal_1' /> Normal
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbImpaired' name='cbImpaired' className='add-only' value='Impaired' /> Impaired
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbIntact' name='cbIntact' className='add-only' value='Intact' /> Intact
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPoorRemote' name='cbPoorRemote' className='add-only' value='PoorRemote' /> Poor remote
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPoorRecent' name='cbPoorRecent' className='add-only' value='PoorRecent' /> Poor recent
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbOther_11' name='cbOther_11' className='add-only' value='Other' />  Other:
                            &nbsp;
                            <input type='text' id='txtOther_12' name='txtOther_12' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>THOUGHT PROCESS</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbLogicalCoherent' name='cbLogicalCoherent' className='add-only' value='LogicalCoherent' /> Logical/Coherent
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbIncomprehensible' name='cbIncomprehensible' className='add-only' value='Incomprehensible' /> Incomprehensible
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbIncoherent' name='cbIncoherent' className='add-only' value='Incoherent' /> Incoherent
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbFlightOfIdeas' name='cbFlightOfIdeas' className='add-only' value='FlightOfIdeas' /> Flight of Ideas
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbLooseAssociation' name='cbLooseAssociation' className='add-only' value='LooseAssociation' /> Loose Association
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbTangential' name='cbTangential' className='add-only' value='Tangential' /> Tangential
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbCircumstantial' name='cbCircumstantial' className='add-only' value='Circumstantial' /> Circumstantial
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbRambling' name='cbRambling' className='add-only' value='Rambling' /> Rambling
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbEvasive' name='cbEvasive' className='add-only' value='Evasive' /> Evasive
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbRacingThoughts' name='cbRacingThoughts' className='add-only' value='RacingThoughts' /> Racing Thoughts
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPerseveration' name='cbPerseveration' className='add-only' value='Perseveration' /> Perseveration
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbThoughtBlocking' name='cbThoughtBlocking' className='add-only' value='ThoughtBlocking' /> Thought Blocking
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbConcrete' name='cbConcrete' className='add-only' value='Concrete' /> Concrete
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbUnremarkable' name='cbUnremarkable' className='add-only' value='Unremarkable' /> Unremarkable
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbOther_13' name='cbOther_13' className='add-only' value='Other' />  Other:
                            &nbsp;
                            <input type='text' id='txtOther_14' name='txtOther_14' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>THOUGHT CONTENT</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAppropriate' name='cbAppropriate' className='add-only' value='Appropriate' /> Appropriate
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbConsistentWithAge' name='cbConsistentWithAge' className='add-only' value='ConsistentWithAge' /> Consistent with Age
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPreoccupations' name='cbPreoccupations' className='add-only' value='Preoccupations' /> Preoccupations
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbObsessions' name='cbObsessions' className='add-only' value='Obsessions' /> Obsessions
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbCompulsions' name='cbCompulsions' className='add-only' value='Compulsions' /> Compulsions
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPhobias' name='cbPhobias' className='add-only' value='Phobias' /> Phobias
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbThoughtBroadcasting' name='cbThoughtBroadcasting' className='add-only' value='ThoughtBroadcasting' /> Thought Broadcasting
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbThoughtInsertion' name='cbThoughtInsertion' className='add-only' value='ThoughtInsertion' /> Thought Insertion
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbThoughtWithdrawal' name='cbThoughtWithdrawal' className='add-only' value='ThoughtWithdrawal' /> Thought Withdrawal
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbIdeasOfReference' name='cbIdeasOfReference' className='add-only' value='IdeasOfReference' /> Ideas of Reference
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbIdeasOfInfluence' name='cbIdeasOfInfluence' className='add-only' value='IdeasOfInfluence' /> Ideas of Influence
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbOther_15' name='cbOther_15' className='add-only' value='Other' />  Other:
                            &nbsp;
                            <input type='text' id='txtOther_16' name='txtOther_16' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>
            </div >
        </form >

    )
}